module.exports = __webpack_public_path__ + "static/ingresso_individual-04b31e0c105504b66ab3dcc4ee28ce40.png";